module.exports = __webpack_public_path__ + "static/media/round.0776eac1.jpg";